import React from 'react';
import { PEILink } from '@/common';
import styles from '@/styles/Socials.module.scss';
import { socialLinks } from '@/common';

export const Socials = () => {
  return (
    <div className={styles['socials-container']}>
      {socialLinks.linkedIn && (
        <PEILink
          href={socialLinks.linkedIn}
          target='_blank'
          className={`${styles['icons']} ${styles.linkSocial}`}
        >
          <i className={`${styles['td-icon-linkedin']} ${styles['td-icon']}`} />
        </PEILink>
      )}
      {socialLinks.twitter && (
        <PEILink
          href={socialLinks.twitter}
          target='_blank'
          className={`${styles['icons']} ${styles.linkSocial}`}
        >
          <i className={`${styles['td-icon-twitter']} ${styles['td-icon']}`} />
        </PEILink>
      )}
    </div>
  );
};
